export function convertMsToFrames(fps: 25 | 30 | 50 | 60, ms: number) {
  const frameEveryMs = 1000 / fps;
  return Math.trunc(ms / frameEveryMs);
}
